import { Buffer } from 'node:buffer'

export const isStringContainsEmptySpaces = (string_) => string_.replaceAll(/\s/g, '').length === 0

export const isStringNotEmpty = (string_) => {
  if (typeof string_ !== 'string') {
    return false
  }
  return Boolean(string_?.trim())
}

export const getInvoiceNumberFromFileName = (fileName) =>
  fileName.split('_').pop().match(/\d/g).join('')

export const base64 = {
  encode: (string) => Buffer.from(string).toString('base64'),
  decode: (string) => Buffer.from(string, 'base64').toString('ascii'),
}

export const replaceConflictingCharacters = (char) => {
  switch (char) {
    case '<': {
      return '&lt;'
    }
    case '>': {
      return '&gt;'
    }
    case '&': {
      return '&amp;'
    }
    case "'": {
      return '&apos;'
    }
    case '"': {
      return '&quot;'
    }
    default: {
      return char
    }
  }
}

export const xmlFormatter = (string = '') => {
  // remove new line, spaces and tabs (more than 1 indent) of the string
  const normalizedString = string.replaceAll(/[\n\t]+| {2,}/g, '')
  // replace all occurrences of the conflicting characters with their corresponding HTML entities.
  return normalizedString.replaceAll(/>([^<]*)</g, (_, content) => {
    // The resulting escaped content is then wrapped in the > and < characters and returned as the replacement string.
    return `>${content.replaceAll(/[<>&'"]/g, replaceConflictingCharacters)}<`
  })
}

export const replaceCamelToDash = (string) => string.replaceAll(/([a-z])([A-Z])/g, '$1 $2')
